import React, { useState } from "react";

import { IdentityDocumentType } from "../../../api/verificationsV2";
import { KycType } from "../../../api/enrichedStakeholder";
import { maskAadhaarNumber } from "../../../components/ui/formelement/v2/EditableField";

import AddDocumentIdModal from "./AddDocumentIdModal";

interface DocumentIdCellProps {
  stakeholderId: string;
  documentType?: IdentityDocumentType;
  documentId?: string;
}

const DocumentIdCell: React.FC<DocumentIdCellProps> = ({
  stakeholderId,
  documentType,
  documentId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!documentType) {
    return <div className="py-1 text-sm text-[#A3A3A3] select-none">Add</div>;
  }

  const isDocumentIdAvailable = Boolean(documentId && documentId.trim() !== "");

  const displayValue =
    documentType === KycType.AADHAAR
      ? maskAadhaarNumber(String(documentId))
      : documentId;

  return (
    <>
      {isDocumentIdAvailable ? (
        <div className="min-w-[140px] py-1 text-sm font-normal text-[#0A0A0A] select-none">
          {displayValue}
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="py-1 text-sm font-normal text-[#0A0A0A]/60 transition-colors focus:outline-none"
        >
          Add
        </button>
      )}

      {isModalOpen && (
        <AddDocumentIdModal
          stakeholderId={stakeholderId}
          documentType={documentType}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default DocumentIdCell;
